import _ from 'lodash';
import { service } from './service';
import { SORT_ORDER } from '@/resources/Constants'
import {
    getGridPagingParams, mapGridPagingState,
    findObjectByPropertyNameInArray,
    removeTimeFromDate
} from '../../../shared/utils';
import { drugReferenceDto } from './dto';
import { IRX_ELIGIBLE_OPTIONS } from '../../../shared/constants';




const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;



const state = {
    brandNameRecords: [],
    selectedBrandNameRecord: {},
    selectedDugDetailCopy: { ...drugReferenceDto },
    paging: {
        ...getGridPagingParams(DEFAULT_SORT_ORDER, 'brand'),
        filters: {
            brand: null,
            isPAPI: IRX_ELIGIBLE_OPTIONS.YES
        }
    },
    referenceDrugKnownNDCsRecords: [],
    referenceDrugKnownNDCsPaging: {
        ...getGridPagingParams(DEFAULT_SORT_ORDER, 'ndC11'),
        filters: {
            ndc11: ''
        }
    },
    copyNDCsFormData: {},
    isNDC11AlreadyExists: false,
};

const getters = {
    files: state => state.files,
    copyNDCsFormData: state => state.copyNDCsFormData
};

const actions = {

    async getBrandNameRecords({ commit, state }, {
        pageNumber = state.paging.pageNumber,
        pageSize = state.paging.pageSize,
        sortBy = state.paging.sortBy,
        sortOrder = state.paging.sortOrder,
        filters = state.paging.filters
    } = {}) {        
        const results = await service.getRecordsByBrandName(pageNumber,
            pageSize,
            sortOrder,
            sortBy,
            filters
        );
        commit('setBrandNameRecords', results);
    },

    async getReferenceDrugKnownNDCs({ commit, state },
        {
            pageNumber = state.referenceDrugKnownNDCsPaging.pageNumber,
            pageSize = state.referenceDrugKnownNDCsPaging.pageSize,
            sortBy = state.referenceDrugKnownNDCsPaging.sortBy,
            sortOrder = state.referenceDrugKnownNDCsPaging.sortOrder,
            filters = state.referenceDrugKnownNDCsPaging.filters,
            brandId
        } = {}) {

        const results = await service.getReferenceDrugKnownNDCs(
            brandId,
            pageNumber,
            pageSize,
            sortOrder,
            sortBy,
            filters
        );
        commit('setReferenceDrugKnownNDCs', results);
    },

    async getBrandDetailById({ state, commit }, brandId) {
        let drugReferenceDetail = { ...drugReferenceDto };

        if (!_.isEmpty(brandId)) {
            const existingDrugReferenceDetail = findObjectByPropertyNameInArray(
                state.brandNameRecords,
                'brandId',
                brandId
            );

            drugReferenceDetail = _.isEmpty(existingDrugReferenceDetail)
                ? drugReferenceDetail
                : existingDrugReferenceDetail;
        }

        commit('setSelectedBranNameByRecById', drugReferenceDetail);

    },

    async saveDrugBrandDetail({ state, commit }, dto) {
        await service.saveDrugBrandRecord(dto);
        commit('updateSelectedBrandNameRecord', drugReferenceDto);
    },

    async updateDrugBrandDetail({ state, commit }, dto) {
        if (dto.brandId) {
            await service.updateDrugBrandRecord(dto);
            commit('updateSelectedBrandNameRecord', dto);
        }
    },

    setNDCsFormDataInState({ state, commit }, ndcFormRecord) {
        commit('setNDCsFormValues', ndcFormRecord);
    },

    resetDrugBrandPagingState({ commit }) {
        commit('resetDrugBrandPagingStateToDefault');
    },

    resetKnownNDCsPagingState({ commit }) {
        commit('resetKnownNDCsPagingStateToDefault');
    },

    async saveReferenceDrugNDCsDetail({ commit, dispatch }, insertedDrugReferenceNDCsDto) {
        await service.saveReferenceDrugNDCsRecord(insertedDrugReferenceNDCsDto);
        commit('saveUpdateReferenceDrugNDCsResponse', dispatch);
    },

    async updateReferenceDrugNDCsDetail({ commit, dispatch }, updatedDrugReferenceNDCsDto) {
        await service.updateReferenceDrugNDCsRecord(updatedDrugReferenceNDCsDto);
        commit('saveUpdateReferenceDrugNDCsResponse', dispatch);
    },

    async checkExistenceOfReferenceDrugNDC11({ state, commit }, referenceDrugNDC11) {
        state.isNDC11AlreadyExists = true;
        state.isNDC11AlreadyExists = await service.checkExistenceReferenceDrugNDC11(referenceDrugNDC11);
    }
};

const mutations = {
    setBrandNameRecords(state, payload) {
        state.brandNameRecords = [];
        payload.items.map(item => {
            let i = state.brandNameRecords.findIndex(x => x.brandId == item.brandId);

            if (i <= -1) {
                state.brandNameRecords.push(item);
            }

            return null;
        });
        ['filters', 'sortBy', 'sortOrder', 'totalItems', 'pageSize', 'pageNumber'].map(key => {
            if (payload.paging.hasOwnProperty(key)) {
                state.paging[key] = payload.paging[key];
            }
        });
    },

    setSelectedBranNameByRecById(state, payload) {
        state.selectedBrandNameRecord = {};
        state.selectedBrandNameRecord = payload;

        const nObj = Object.assign(
            {},
            state.selectedDugDetailCopy,
            payload
        );
        state.selectedDugDetailCopy = nObj;
    },

    resetDrugBrandPagingStateToDefault(state, payload) {

        state.paging = {
            ...getGridPagingParams(DEFAULT_SORT_ORDER, 'brand'),
            filters: {
                brand: null,
                isPAPI: IRX_ELIGIBLE_OPTIONS.YES
            }
        };

        state.brandNameRecords = [];

    },

    resetKnownNDCsPagingStateToDefault(state, payload) {

        state.referenceDrugKnownNDCsPaging = {
            ...getGridPagingParams(DEFAULT_SORT_ORDER, 'ndC11'),
            filters: {
                ndc11: ''
            }
        };

        state.referenceDrugKnownNDCsRecords = [];

    },

    setReferenceDrugKnownNDCs(state, payload) {
        const pagingData = payload && payload.paging;

        state.referenceDrugKnownNDCsRecords = payload && payload.items;

        state.referenceDrugKnownNDCsPaging = mapGridPagingState(
            state.referenceDrugKnownNDCsPaging,
            pagingData
        );

    },

    updateSelectedBrandNameRecord(state, updatedSelectedBrandNameRecord) {
        state.selectedBrandNameRecord = {
            ...updatedSelectedBrandNameRecord,
            isPAPI: updatedSelectedBrandNameRecord.iRxEligible,
            isPAPR: updatedSelectedBrandNameRecord.retailEligible,
            edate: removeTimeFromDate(updatedSelectedBrandNameRecord.endDate),
        }
        state.selectedDugDetailCopy = { ...updatedSelectedBrandNameRecord };
    },

    setNDCsFormValues(state, ndcFormRecord) {
        const copiedObj = Object.assign(
            {},
            ndcFormRecord
        );
        state.copyNDCsFormData = copiedObj;
        state.isNDC11AlreadyExists = false;
    },

    saveUpdateReferenceDrugNDCsResponse(state, dispatch) {

        let referenceDrugKnownNDCsPagingState = { ...state.referenceDrugKnownNDCsPaging };
        referenceDrugKnownNDCsPagingState.brandId = state.selectedBrandNameRecord.brandId;

        dispatch("getReferenceDrugKnownNDCs", referenceDrugKnownNDCsPagingState);
    }
};

const brandName = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default brandName;
